import { Switch, Text } from '@byecode/ui'
import { ListItem4ByecodeUi } from '@lighthouse/shared'

interface Props {
    value?: boolean
    onChange?: (v: boolean) => void
}

export const AutoFocus = ({ value, onChange }: Props) => {
    return (
        <ListItem4ByecodeUi enableHover justifyContent="space-between" alignItems="center">
            <Text>自动聚焦</Text>
            <Switch checked={value} onChange={e => onChange?.(e.currentTarget.checked)} />
        </ListItem4ByecodeUi>
    )
}
